import React, { Component } from "react";

class Footer extends Component {
  render() {
    const currYear = new Date().getFullYear();
    return (
      <div className="footer-container">
        <div className="footer-rights">
          All rights reserved &copy; {currYear}.
        </div>
        <div className="footer-creator">Created with ❤️ by Abdelrahman.</div>
      </div>
    );
  }
}

export default Footer;
